<template>
	<div id="RightNav">
		<div class="flex infoUser flex-between ">
			<div class="flex" style="align-items: center;">
				<div class="stuinfo pointer" v-if="userId">
					<div class="face" @click="goAccountSettings">
						<img v-if="!userInfo.logoPath" src="../assets/images/common/defaultpic.png">
						<img v-else :src="global.getOssFileUrl(userInfo.logoPath)">
						<!-- <template v-if="freeCard">
							<template v-if="freeCardObj.endTime > new Date().getTime()">
                <img src="../assets/images/center/ico-changxuekauserphoto01.png" alt="" class="headFree01">
                <img src="../assets/images/center/ico-changxuekauserphoto01-2.png" alt="" class="headFree02">
              </template>
              <template v-else>
                <img src="../assets/images/center/ico-changxuekauserphoto02.png" alt="" class="headFree01">
                <img src="../assets/images/center/ico-changxuekauserphoto02-2.png" alt="" class="headFree02">
              </template>
						</template> -->
						<!-- v-if="isHasFree" -->
						<template v-if="freeCard">
							<!-- v-if="FreeCard && FreeCard.endTime > new Date().getTime()" -->
              <template v-if="freeCardObj && freeCardObj.endTime > new Date().getTime()">
                <img src="../assets/images/center/headaBj.gif" alt="" class="headFree01">
                <img src="../assets/images/center/headaBj.png" alt="" class="headFree02">
              </template>
            </template>
					</div>
					<div class="name-box">
						<span @click="goAccountSettings" class="name linelimit font-16" :title="userInfo.fullName">{{userInfo.fullName}}</span>
						<!-- <div v-if="freeCard" @click="tobuyCard" class="free-card-text">
							<template v-if="freeCardObj.endTime > new Date().getTime()">
								畅学卡剩余：{{countdownDay(freeCardObj.endTime)}}天<img src="../assets/images/center/more.png" class="hasrightIcon">
							</template>
							<template v-else>
								你的畅学卡已到期<img src="../assets/images/center/more.png" class="hasrightIcon">
							</template>
						</div>
						<div v-else @click="tobuyCard" class="free-card-text">
							开通畅学卡<img src="../assets/images/center/more.png" class="hasrightIcon">
						</div> -->
						
            <template v-if="freeCard">
              <template v-if="freeCardObj && freeCardObj.endTime > new Date().getTime()">
                <div class="freeMyWarp"  @click.stop="tobuyCard"><template v-if="langMode == 'en'"><img src="../assets/images/center/changxueka02-en.png" alt="" class="changxuekas"></template><template v-else><img src="../assets/images/center/changxueka02.png" alt="" class="changxuekas"></template><span :class="{'pr3':langMode == 'en'}">{{$t('newCenter.Remaining')}} </span> {{countdownDay(freeCardObj.endTime)}} {{$t('newCenter.Days')}}</div>
              </template>
              <template v-else>
                <div class="freeMyWarp"  @click.stop="tobuyCard"><template v-if="langMode == 'en'"><img src="../assets/images/center/changxueka01-en.png" alt="" class="changxuekas"></template><template v-else><img src="../assets/images/center/changxueka01.png" alt="" class="changxuekas"></template><span>{{$t('newCenter.RenewStudyPass')}}</span></div>
              </template>
            </template>
						<template v-else>
              <div class="freeMyWarp" @click.stop="tobuyCard">
                <span>{{$t('newCenter.ActivateStudyPass')}}</span>
              </div>
            </template>
					</div>
				</div>
				<div class="stuinfo pointer" v-else @click="toLogin">
					<div class="face">
						<img src="../assets/images/center/ico-right-userpic-default.png">
					</div>
					<span class="name linelimit font-16"> {{$t('newCenter.dlzc')}} </span>
				</div>
				<img src="../assets/images/center/ico-right-newhavegift.png" alt="" v-if="XRYL" class="newhavegift pointer"
					@click="openXryl">
				<img src="../assets/images/center/ico-right-newhavegift2.png" alt="" v-if="freeCrmDialogNav"
					class="newhavegift pointer" @click="openCrm">
			</div>
			<div class="flex pointer">
				<div class="topbtn notice" @click="goNoticeView">
					<img src="../assets/images/center/ico-right-msg.png" alt="">
					<span :class="{ 'not_read ': hasNotReaded,'newIm not_read':newImMsg }"></span>
				</div>

			</div>

		</div>


		<div class="flex m-lr-10">
			<div class="achieveCell">
				<div class="key font-14">{{ $t("newCenter.jxj") }}</div>
				<div class="value font-18 ellipsis pointer" @click="sq(1)">{{ amountAccount || 0 }}</div>

			</div>
			<div class="achieveCell">
				<div class="key font-14">{{ $t("newCenter.ttlxf") }}</div>
				<div class="value font-18 ellipsis pointer" @click="sq">{{ totalScore || 0 }}</div>

			</div>
			<div class="achieveCell">
				<div class="key font-14">{{ $t("newCenter.yhj") }}</div>
				<div class="value font-18 ellipsis pointer" @click="sq(3)">{{ couponNum || 0 }}</div>

			</div>
		</div>
		<div class="font-14 flex user-phone m-lr-10 ">
			<img src="../assets/images/center/ico-right-phone.png" alt="">
			<div>{{mobilePhone || $t("newCenter.zw")}}</div>
		</div>
		<div class="font-14 flex user-phone m-lr-10">
			<img src="../assets/images/center/ico-right-email.png" alt="">
			<div class="ellipsis">{{userInfo&&userInfo.email || $t("newCenter.zw")}}</div>
		</div>


		<div class="certificate flex m-lr-10 flex-between pointer" @click="clickMyAchievement('certificate')">
			<div class="font-14" v-if="certificateNum==0">{{ $t("newCenter.zw") }}</div>
			<div v-else class="flex">
				<img v-for="(v,k) in certificateNum" :key="v"
					:src="require(`../assets/images/center/ico-right-pride${k+1}.png`)" v-if="k<4" alt="" class="zsIcon">
			</div>
			<div class="flex font-14" style="align-items: center;">
				{{ $t("newCenter.gdcj") }}
				<img src="./learning/img/more.png" alt="" class="moreImg">
			</div>

			<!-- <div class="todo_acquired" v-if="notCertificateExamObj.totalNum">待获取</div> -->
		</div>

		<div class="stdy-shaw m-lr-10 pointer" @click="toFree">
			<div class="myFree flex">
				<div class="myFreeContent flex">
					<div class="freeText">
						<div class="freeText01 font-18">{{ $t("newCenter.gmcxk") }}</div>
						<div class="freeText02 font-12">{{ $t("newCenter.zktq") }}</div>
					</div>
				</div>
				<div class="free_back">
					<img src="./learning/img/more.png" alt="" class="moreImg">
				</div>
			</div>
		</div>

		<div class="dutyCont m-lr-10">
			<div v-for="(item, index) in dutyList" :key="index" @click="goRouter(item.url, item.type, item.status)"
				class="dutyList pointer">
				<img :src="require(`../assets/images/center/${item.icon}.png`)" alt="" />
				<!-- ellipsis -->
				<div class="dutyList-name font-14 color-6 ">{{ item.name }}</div>
			</div>
		</div>

		<div class="bottominfo  font-14">
			<div class="download ellipsis pointer" @click="installNeo()"><a href="#">{{$t("my.neoDownload")}}</a></div>
			<div class="phone ellipsis">{{$t("my.technicalPhone")}} 18551796207</div>
			<div class="time ellipsis">{{$t("my.workingHours")}} 9:00-22:00</div>
			<div class="email ellipsis">{{$t("my.enquireEmail")}} support@dailyedu.com</div>
		</div>
		<van-overlay :show="exchangeshow">
			<div class="wrapper">
				<div class="block" @click.stop>
					<h2 class="title">兑换</h2>
					<p class="tips">输入兑换码领取课程</p>
					<van-field class="exchange_ipt" v-model="echange_value" placeholder="输入兑换码" />
					<div class="footer_btn">
						<div class="cancle pointer" @click="exchangeshow = false">
							{{ $t('common.cancel') }}
						</div>
						<div class="confrime pointer" @click="btnFlag ? handleEchangeBtn() : null">
							{{ $t('common.confirm') }}
						</div>
					</div>
				</div>
			</div>
		</van-overlay>

		<van-overlay :show="freeDialog" @click="freeDialog = false">
			<div class="bullet-box-wrap">
				<div class="XrfreeContent">
					<img src="../assets/images/center/ico-newuserhavegift.png" class="newuserhavegift">
					<div class="dialog_title ">畅学周卡 <span>「 0元领 」</span></div>
					<div class="dialog_des ">累计领卡: <span>{{freeNum}}</span>人 </div>
					<img src="../assets/images/center/img-newusergiftmore.png" class="img-newusergiftmore">
					<div class="confirm1  p-lr-15 pointer" @click="lq">
						速领取
					</div>
				</div>
				<img src="../assets/images/center/close-w.png" class="bullet-box-close pointer" @click="colseFree">
			</div>
		</van-overlay>


		<van-overlay :show="qRCode" @click="qRCode = false">
			<div class="bullet-box-wrap">
				<div class="XrfreeContent" style="padding: 20px 15px;">
					<div class="dialog_title ">恭喜你已成功领取畅学卡</div>
					<div class="dialog_des " style="background: transparent;color: #333;width: auto;">添加专属教务可获取专业学习指导哦</div>
					<img src="../assets/images/center/any.jpg" class="img-newusergiftmore">
					<div class="confirm1  p-lr-15 pointer" @click="qRCode = false">
						我知道了
					</div>
				</div>
				<img src="../assets/images/center/close-w.png" class="bullet-box-close pointer" @click="qRCode = false">
			</div>
		</van-overlay>



		<div class="pagebodyWrap" v-if='freeCrmDialog'>
			<div class="bullet-box-wrap">
				<div class="crmfreeContent">
					<img src="../assets/images/center/crmTitle.png" class="crmTitle">
					<div class="flex learningCardCon"
						:class="{'oneList':learningCrmCard.length==1,'twoList':learningCrmCard.length==2}">
						<div v-for="item in learningCrmCard" :key="item.id" class="learningCardList"
							:class="{'activeCard': (nowSelect&&nowSelect.orderNo) == item.orderNo}" @click="selectCard(item)">
							<div class="productName">{{item.productName}}</div>
							<!-- <div class="suggestPrice flex">价值<div class="val">{{item.suggestPrice}}</div>元</div> -->
						</div>
					</div>
					<img src="../assets/images/center/crmdown3.png" class="img-newusergiftmore">
					<div class="confirm1  p-lr-15" @click="lqCrm">
						速领取
					</div>
				</div>
				<img src="../assets/images/center/close-w.png" class="bullet-box-close" @click="colseCrm">
			</div>

		</div>

		<div class="pagebodyWrap" v-if="downloadAppShow">
			<div class="bullet-box-wrap">
				<div class="crmfreeContent" style="padding: 0;">
					<img src="../assets/images/center/crmdown1.png" alt="" class="crmdown1">
					<div class="rqcode-item font-15">
						上岱恩语培app进行学习哦
					</div>
					<div class="rqcode-title font-15 flex">
						下载岱恩语培App，<div>畅学模块任你学</div>
					</div>
					<div class="flex flex-between" style="width: 100%;">
						<div class="share-qrcode-img1">
							<img src="../assets/images/center/crmdown2.png" alt="">
						</div>
					</div>
				</div>

			</div>
		</div>

		<!-- <imChatWin ref="imChatWin" v-if="userId"></imChatWin> -->
	</div>
</template>
<script>
	import imChatWin from "@/components/common/imChatWin.vue";
	import {
		mapMutations
	} from "vuex";
	export default {
		components: {
			imChatWin
		},
		data: function() {
			return {
				customerGuid: null,
				freeCrmDialogNav: false,
				learningCrmCard: [],
				freeCrmDialog: false,
				downloadAppShow: false,
				nowSelect: null,
				qRCode: false,
				learningCard: null,
				freeNum: 1000,
				freeCardObj: null,
      	freeCard: false,
				XRYL: false,
				freeDialog: false,
				echange_value: '',
				btnFlag: true,
				exchangeshow: false,
				notCertificateExamObj: {
					list: [],
					totalNum: 0
				},
				dutyList: [{
						icon: 'center1',
						name: this.$t("newCenter.myLesson"),
						url: '/my/EndedCourse',
						type: 0,
						status: false
					},
					{
						icon: 'center2',
						name: this.$t("newCenter.xlyjs"),
						url: '/my/competition',
						type: 0,
						status: true
					},
					{
						icon: 'center3',
						name: this.$t("newCenter.ks"),
						url: '/my/myExam',
						type: 0,
						status: false
					},
					{
						icon: 'center4',
						name: this.$t("newCenter.sc"),
						url: '/my/collect',
						type: 0,
						status: true
					},
					{
						icon: 'center5',
						name: this.$t("newCenter.yxls"),
						url: '/my/favoriteTeacher',
						type: 0,
						status: false
					},
					{
						icon: 'center6',
						name: this.$t("newCenter.gj"),
						url: '/follow/list',
						type: 0,
						status: false
					},
					// {
					// 	icon: 'center12',
					// 	name: '兑换',
					// 	url: '/certificate/myCertificate',
					// 	type: 1,
					// 	status: true
					// },
					{
						icon: 'center8',
						name: this.$t("newCenter.kcdd"),
						url: '/order/orderList',
						type: 0,
						status: false
					},
					{
						icon: 'center18',
						name: this.$t("newCenter.lljl"),
						url: '/my/browsingHistory',
						type: 0,
						status: false
					},
					{
						icon: 'center19',
						name: this.$t("newCenter.dcb"),
						url: '/word/myWord',
						type: 0,
						status: false
					}
				],
				certificateNum: 0,
				amountAccount: 0,
				totalScore: 0,
				couponNum: 0,
				mobilePhone: null,
				userInfo: {},
				lang: localStorage.getItem("lang"),
				newImMsg: false, // 是否有新消息
				language: this.$store.state.common.lang,
				userId: localStorage.getItem("userId"),
				langMode: null,
			};
		},
		created() {
			this.$root.Bus.$on("newImMeg", v => {
				console.log("newImMeg", v);
				if (v && this.$route.name != "notice") {
					setTimeout(() => {
						this.newImMsg = true;
					}, 5);
				}
			});
			let langMode = localStorage.getItem('lang')
			if (!langMode) {
				this.langMode = 'zh'
			} else {
				this.langMode = localStorage.getItem('lang')
			}
		},
		beforeDestroy() {
			this.$root.Bus.$off("newImMeg");
		},
		mounted() {
			this.initPage()
			this.getCertificateNum();
			this.getNotCertificateExam();
			this.getFree()
			let threeFlowers = localStorage.getItem('threeFlowers') || localStorage.getItem('crmPage') || null
			let crmPage = localStorage.getItem('crmPage') || null
			if (!threeFlowers) {
				this.getCardActivity()
			}
			if (crmPage) {
				this.customerGuid = crmPage
				this.getCrm()
			}

		},
		computed: {
			subMenu() {
				return [{
						menu: this.$t("menu.accountSettings"),
						link: "accountSettings"
					},
					{
						menu: this.$t("menu.endedCourse"),
						link: "endedCourse"
					},
					// { menu: "我的订单", link: "" },
					// { menu: "我参与的", link: "" },
					// { menu: "我的优惠券", link: "" },
					{
						menu: this.$t("menu.notice"),
						link: "notice"
					},
					{
						menu: this.$t("myJoin.myExam"),
						link: "myExam"
					},
					{
						menu: this.$t("msg.category6"),
						link: "follow"
					}
					// { menu: "技术帮助", link: "" },
					// { menu: "投诉建议", link: "" },
					// { menu: "其他设置", link: "" }
				];
			},
			curMenu() {
				return this.$store.state.common.curMenu;
			},
			noReadMsgList() {
				return this.$store.state.common.noReadMsgList;
			},
			hasNotReaded() {
				// 读取缓存是否有未读
				let notRead = false;
				let categoryList = [
					"DKTZ",
					"SKTZ",
					"ZYTZ",
					"PJTZ",
					"KSTZ",
					"DKTZ",
					"HDTZ",
					"XSTZ",
					"YXTZ",
					"QTTZ"
				];
				categoryList.forEach(item => {
					if (this.noReadMsgList[item] > 0) {
						notRead = true;
						return notRead;
					}
				});
				return notRead;
			}
		},
		methods: {
			openCrm() {
				this.freeCrmDialog = true
			},
			colseCrm() {
				let time = this.global.formatDate(new Date().getTime(), 'yyyy.mm.dd');
				localStorage.setItem(time + '_xrylCrm', 1);
				this.freeCrmDialog = false
			},
			lqCrm() {
				if (!this.nowSelect) {
					this.$message.error('请选择卡');
					return
				}
				let obj = {
					orderNo: this.nowSelect.orderNo,
					studentId: this.userId,
					studentName: this.userInfo.nickName,
					mobile: this.userInfo.mobilePhone,
					cardName: this.nowSelect.productName,
					cardType: this.nowSelect.prodCharacter
				}
				if (this.nowSelect.paymentType == 'COMPANY-PAY') {
					obj.limit = this.nowSelect.quantitySold
				}
				if (this.nowSelect.prodCharacter == 'define') {
					obj.validityDays = this.nowSelect.prodCharacterValue
				}

				this.request
					.post(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/free/crm/takeCard`, obj
					)
					.then((res) => {
						if (res.success) {
							this.Toast('领取成功');
							this.freeCrmDialogNav = false;
							this.freeCrmDialog = false
							localStorage.removeItem('freeCardRecord')
							localStorage.removeItem('isDiscount')
						
						} else {
							this.freeCrmDialogNav = false;
							this.freeCrmDialog = false
							this.$message.error(res.message)
						}
					})
			},
			selectCard(item) {
				this.nowSelect = item
			},
			getCrm() {

				// `http://192.168.2.64:8080/crmrpc/changxue/${this.customerGuid}`
				// `${this.WITSBOX_ENV_PARAM.crmApi}/crmrpc/changxue/${this.customerGuid}`
				this.request
					.get(
						`${this.WITSBOX_ENV_PARAM.crmApi}/crmrpc/changxue/${this.customerGuid}`
					)
					.then((res) => {
						if (res.code == 200) {
							let dataModel = res.data || null
							// dataModel 为null 代表终止或者作废
							if (dataModel) {
								let orderView = dataModel.orderView;
								let arr = orderView.filter((i) => {
									return i.paymentType != 'PERSONAL-PAY'
								})
								let orderNo = arr.map((i) => {
									return i.orderNo
								})
								let obj = {
									orderNos: orderNo
								}
								this.getIsCard(obj, arr)

							} else {
								// this.zhzf = true
								// this.downloadAppShow = true
								setTimeout(() => {
									localStorage.removeItem('crmPage')
									if (this.WITSBOX_ENV_PARAM.baseUrl == 'https://t.witsbox.com/api') {
										window.location.href = `https://t.witsbox.com/student/learning`
									} else if (this.WITSBOX_ENV_PARAM.baseUrl == 'https://t.dailyedu.com/api') {
										window.location.href = `https://t.dailyedu.com/student/learning`
									} else if (this.WITSBOX_ENV_PARAM.baseUrl == 'https://hk.witsbox.com/api') {
										window.location.href = `https://hk.witsbox.com/student/learning`
									} else if (this.WITSBOX_ENV_PARAM.baseUrl == 'https://hk.dailyedu.com/api') {
										window.location.href = `https://hk.dailyedu.com/student/learning`
									} else {
										window.location.href = `https://www.dailyedu.com/student/learning`
									}
								}, 500)
							}

						}
					})

			},
			getIsCard(obj, arr) {
				if (!this.userId) return

				this.request
					.post(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/free/crm/hasTakeCard?studentId=${this.userId}`, obj
					)
					.then((res1) => {
						if (!res1.dataModel) {
							this.getCardInfo(obj, arr)
						}
					})


			},
			getCardInfo(obj, arr) {
				let this_ = this;
				this.request
					.post(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/free/crmFreeCard`, obj
					)
					.then((res) => {
						if (res.dataModel) {
							let data = res.dataModel;
							var keys1 = [];
							for (var p1 in data) {
								if (data.hasOwnProperty(p1))
									keys1.push({
										orderNo: p1,
										quantitySold: data[p1]
									});
							}
							console.log(keys1)
							console.log(arr)
							var uniqueArr = []
							for (let i = 0; i < arr.length; i++) {
								let item_1 = keys1.find(e => e.orderNo == arr[i].orderNo);
								if(item_1){
									if(arr[i].paymentType=="FREE-GIFT"){
										uniqueArr.push(arr[i])
									}else {
										if(arr[i].quantitySold!=0){
											if(arr[i].orderNo == item_1.orderNo && arr[i].quantitySold == item_1.quantitySold){
												
											}else{
												uniqueArr.push(arr[i])
											}
										}	
									}
								}
							}
							let arr_ = uniqueArr.reduce((acc, current) => {
									const x = acc.find(item => item.orderNo === current.orderNo);
									if (!x) {
											return acc.concat([current]);
									} else {
											return acc;
									}
							}, []);
							console.log(arr_)
							this.learningCrmCard = arr_;
							if (arr_.length > 0) {
								this.freeCrmDialogNav = true
								let time = this.global.formatDate(new Date().getTime(), 'yyyy.mm.dd');

								let xryl = localStorage.getItem(time + '_xrylCrm') || null;
								if (!xryl) {
									this.freeCrmDialog = true
								}

							}
							if (arr_.length == 1) {
								this.nowSelect = this.learningCrmCard[0]
							}

						}
					})
			},

			goAccountSettings() {
				this.$router.push({
					path: "/my/accountSettings"
				});
			},
			tobuyCard() {
				if(this.customerGuid){
					this.$router.push({
						path: `/free/crm/${this.customerGuid}`
					})
				}else{
					this.$router.push({
						path: '/free/freeLearningCardBuying'
					})
				}
				
			},
			sq(type) {
				if (this.userId) {
					if (type == 3) {
						this.$router.push({
							path: "/coupon/couponList"
						});
					}
					if (type == 1) {
						this.$router.push({
							path: "/my/myScholarship"
						});
					}

				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}
			},
			getCardActivity() {
				this.request
					.get(`${this.WITSBOX_ENV_PARAM.baseUrl}/free/learningCardActivity`)
					.then((res) => {
						if (res.success) {
							if (res.dataModel) {
								let nowTime = Date.parse(new Date())
								this.learningCard = res.dataModel;
								this.learningCard.nowTime = nowTime;
								this.getTakeCard()

							}
						}
					})
			},
			twoTimeInterval() {
				var ms = Math.abs(new Date().getTime() - this.learningCard.startTime);
				if (ms < 0) return 1000;
				console.log("twoTimeInterval==>", ms);
				let hour = Math.floor(ms / 1000 / 60 / 60);
				return hour * 10 + 1000;
			},
			getTakeCard() {
				let obj = {
					...this.learningCard
				}
				if (!this.userId) {
					return false
				}
				this.request
					.get(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/free/${this.mobilePhone}/freeCardRecord`
					)
					.then((res) => {
						if (res.success) {

							console.log(12121212, res.dataModel)
							let time = this.global.formatDate(new Date().getTime(), 'yyyy.mm.dd');
							let xryl = localStorage.getItem(time + '_xryl') || null;;
							if (!res.dataModel) {
								xryl = localStorage.getItem(time + '_xryl') || null;
								this.XRYL = true
							} else {
								localStorage.setItem('cx_xryl', 1);
							}
							if (!xryl) {
								if (!res.dataModel) {
									this.freeDialog = true;
								}
							} else {
								this.freeDialog = false;

							}

							this.freeNum = this.twoTimeInterval();

						}
					})

			},
			lq() {
				this.request
					.post(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/free/${this.userInfo.mobilePhone}/takeCard`, {
							channel: 'app'
						}
					)
					.then((res) => {
						if (res.success) {
							this.Toast('领取成功');
							this.freeDialog = false;
							this.XRYL = false
							// this.$emit('freeNORw');
							localStorage.removeItem('freeCardRecord')
							localStorage.removeItem('isDiscount')
							setTimeout(() => {
								this.qRCode = true
							}, 1000)
						}
					})


			},
			colseFree() {
				let time = this.global.formatDate(new Date().getTime(), 'yyyy.mm.dd');

				localStorage.setItem(time + '_xryl', 1);
				this.freeDialog = false;

			},
			// 点击兑换码逻辑
			handleEchangeBtn() {
				if (this.userId) {
					if (!this.btnFlag) {
						return
					}
					if (this.echange_value.trim().length == 0) {
						return this.Toast('输入兑换码')
					}
					// 请求
					this.btnFlag = false
					this.request
						.put(
							`${
			        this.WITSBOX_ENV_PARAM.baseUrl
			      }/shop/redeemCode/${this.echange_value.trim()}?mobile=${
			        this.mobilePhone
			      }`
						)
						.then((res) => {
							if (res.success) {
								this.btnFlag = true
								this.Toast('兑换成功')
								// this.$router.push({
								// 	path: '/getCourseResult',
								// 	query: {
								// 		redeemCode: this.echange_value
								// 	}
								// })

								this.exchangeshow = false
							} else {
								this.Toast(res.message)
								this.btnFlag = true
							}
						})
				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}

			},
			toFree() {

				if (this.userId) {
					let threeFlowers = localStorage.getItem('threeFlowers') || null
					let crmPage = localStorage.getItem('crmPage') || null
					if (threeFlowers) {
						this.$router.push({
							path: `/free/card-${threeFlowers}`
						})
					} else if (crmPage) {
						this.$router.push({
							path: `/free/crm/${crmPage}`
						})
					} else {
						this.$router.push({
							path: '/free/freeLearningCardBuying'
						})
					}


				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}


			},
			getNotCertificateExam() {
				if (!this.userId) return
				let url =
					`${this.WITSBOX_ENV_PARAM.baseUrl}/project/notCertificateExam/${this.userId}?tem=${new Date().getTime()}`
				this.request.get(url).then(res => {
					this.notCertificateExamObj = res.dataModel || {
						list: [],
						totalNum: 0
					}
				})
			},
			getFree(){
				if (this.userId) {
					this.global.getIsDiscount((res) => {
						let FreeCard = res
						if (FreeCard) {
							this.freeCard = true
							this.freeCardObj = res
						}
					})
				}
			},
			countdownDay(dateBegin) {
				var dateEnd = new Date() // 获取当前时间
				var dateDiff = dateBegin - dateEnd.getTime() // 时间差的毫秒数
				var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)) // 计算出相差天数
				return this.$add(dayDiff, 1)
			},
			installNeo() {
				this.$store.dispatch("common/changeNeoCodeVisible", true)
			},
			goRouter(val, type, status) {
				console.log(val);
				if (this.userId) {
					if (type == 1) {
						this.echange_value = ''
						this.exchangeshow = true
					} else {
						this.$router.push({
							path: val
						})
					}

				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}

			},
			getCertificateNum() {

				if (this.userId) {
					this.request.get(
							`${this.WITSBOX_ENV_PARAM.baseUrl}/project/certificateNum/${this.userId}?tem=${new Date().getTime()}`)
						.then((res) => {
							this.certificateNum = res && res.dataModel || 0
						});
				}

			},
			initPage() {
				if (!this.userId) return;
				this.mobilePhone = JSON.parse(localStorage.getItem('userInfo')).mobilePhone
				this.request
					.get(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/user/userAccount?mobilePhone=${this.mobilePhone}`
					)
					.then(res => {
						if (res.success) {
							this.userInfo = res.dataModel.object;
							this.userInfo.headUrl = res.dataModel.url;
							this.amountAccount = res.dataModel.amountAccount
							this.couponNum = res.dataModel.couponNum

							this.totalScore = res.dataModel.totalScore
						}
					});
			},
			switchLang() {
				this.$store.dispatch("common/changeLanguageDialogVisible", true);

			},
			openXryl() {
				if (this.userId) {
					this.freeDialog = true;

				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}
			},
			goNoticeView() {
				if (this.userId) {
					this.newImMsg = false;
					this.$router.push({
						path: "/my/notice"
					});
				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}


			},
			clickMyAchievement(type) {
				if (this.userId) {
					this.$router.push({
						path: '/certificate/myCertificate'
					})
				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}
				}
			},
			toLogin() {
				this.$emit("loginDialog", true);
			},
			exitLogin() {
				// let loginForm = localStorage.getItem("loginForm");

				localStorage.clear();
				sessionStorage.clear();
				// if (loginForm) {
				//   localStorage.setItem("loginForm", loginForm);
				// }
				window.location.href = `${
			  this.WITSBOX_ENV_PARAM.loginPage
			}#/learning/index`;


				// this.$router.replace({
				//   path: "/user/login"
				// });
			},
			goStudyCenter() {
				if (this.userId) {
					this.$router.push({
						path: "/study/center"
					});
				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)
						window.location.reload();
					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}
			},
			goCX() {
				this.$router.push({
					path: `/learning/index`
				});
			},
			gotoMenu(ele) {
				if (!ele) {
					return;
				}
				if (this.userId) {
					if (ele == "follow") {
						this.$router.push({
							path: `/follow/list`
						});
					} else {
						this.$router.push({
							path: `/my/${ele}`
						});
					}
				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}
			},
			...mapMutations("common", ["CHANGELANG"])
		}
	};
</script>
<style>
	@keyframes newIm {
		from {
			opacity: 1;
		}

		to {
			opacity: 0;
		}
	}
</style>
<style scoped lang="scss">
.pr3 {
	padding-right: 3px;
}
	/deep/ .van-overlay {
		z-index: 40 !important;
	}

	.bullet-box-wrap {
		width: 310px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
	}

	.achieveCell {
		flex: 1;
		width: 33%;
		text-align: center;
		position: relative;
		margin-bottom: 1.36rem;

		.key {

			height: 0.6rem;
			line-height: 0.6rem;
			font-family: PingFang SC;
			font-weight: 500;
			color: #666666;
			margin-bottom: 0.48rem;
		}

		.value {
			height: 0.8rem;
			line-height: 0.8rem;
			font-family: PingFang SC;
			font-weight: bold;
			color: #1F85FC;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			text-align: center;
		}
	}

	.infoUser {
		margin: 0.8rem 0.64rem 1.12rem 0.48rem;

		.newhavegift {
			width: 3.4rem;
			height: 1.12rem;

			border-radius: 0.24rem;
		}

		.topbtn {
			width: 1.6rem;
			height: 1.6rem;
			position: relative;

			img {
				width: 1.6rem;
				height: 1.6rem;
			}

			.not_read {
				position: absolute;
				width: 0.24rem;
				height: 0.24rem;
				background: #FF5962;
				border-radius: 50%;
				top: 0.3rem;
				right: 0.34rem;
			}

			.newIm {
				animation: newIm linear 1.5s infinite;
			}


		}
	}

	.user-phone {
		height: 1.2rem;
		line-height: 1.2rem;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		margin-bottom: 0.4rem;

		img {
			margin-left: 0.4rem;
			width: 1.2rem;
			height: 1.2rem;
			margin-right: 0.4rem;
		}

	}

	.certificate {
		margin: 0.8rem 0.8rem 1rem 1.2rem;
		height: 1.2rem;
		line-height: 1.2rem;

		.zsIcon {
			height: 1.28rem;
			width: 1.28rem;
			margin-right: 0.4rem;
		}

		.moreImg {
			height: 0.8rem;
			width: 0.8rem;

		}
	}

	.stuinfo {
		height: 2rem;
		line-height: 2rem;
		display: flex;

		.face {

			position: relative;
			width: 2rem;
			height: 2rem;
			// border: 0.08rem solid #FFFFFF;
			box-shadow: 0.32rem 0.32rem 1rem 0px rgba(23, 39, 74, 0.1);
			border-radius: 50%;
			margin-right: 0.4rem;

			img {
				border-radius: 50%;
				width: 100%;
				height: 100%;
			}
			// .headFree01 {
			// 	width: 0.6rem !important;
			// 	height: 0.6rem !important;
			// 	border-radius: 0 !important;
			// 	position: absolute;
			// 	top: 0;
			// 	right: 0;
			// 	transform: translate(50%,-40%);
			// }
			// .headFree02 {
			// 	width: 1.72rem !important;
			// 	height: 0.68rem !important;
			// 	border-radius: 0 !important;
			// 	position: absolute;
			// 	bottom: 0;
			// 	left: 50%;
			// 	transform: translate(-50%,40%);
			// }
			.headFree01 {
				width: 3.2rem;
				height: 3.2rem;
				position: absolute;
				top: -0.64rem;
				left: -0.64rem;
				z-index: 2;
			}
			.headFree02 {
				width: 3.2rem;
				height: 3.2rem;
				position: absolute;
				top: -0.64rem;
				left: -0.64rem;
				z-index: 1;
			}
		}
		.name-box{
			display: flex;
			flex-direction: column;
			line-height: normal;
			justify-content: space-evenly;
			flex: 1;
			.freeMyWarp {
        font-size: 0.4rem;
        color: #FFF;
        margin-top: 0.24rem;
        display: flex;
        align-items: center;
        line-height: 0.72rem;
        height: 0.72rem;
        background: #2041A8;
        border-radius: 0.36rem;
        padding-right: 0.32rem;
        span {
          padding-left: 0.32rem;
        }
      }
      .changxuekas {
        width: 2.4rem;
        height: 0.72rem;
        display: flex;
      }
		}
		.name {
			font-family: PingFang SC;
			font-weight: 500;
			color: #333333;
			font-size: 0.64rem;
			margin-right: 0.24rem;
			max-width: 3.2rem;
		}
		.free-card-text{
			cursor: pointer;
			font-size: 0.48rem;
			color: #666666;
		}
		.hasrightIcon {
      width: 0.2rem;
      height: 0.4rem;
      margin-left: 0.2rem;
    }
	}

	.login1 {

		font-size: 16px;
		height: 30px;
		display: block;
		float: left;
		line-height: 30px;
		padding: 0 30px;
		border-left: 1px solid rgba(255, 255, 255, 0.6);
	}

	.dutyCont {
		display: flex;
		flex-wrap: wrap;

		.dutyList {
			width: 33.3%;
			text-align: center;

			img {

				width: 2rem;
				height: 2rem;
				display: block;
				margin: 0 auto;
				margin-top: 0.88rem;
				margin-bottom: 0.24rem;
				border-radius: 50%;

			}

			.dutyList-name {
				height: 0.6rem;
				line-height: 0.6rem;
				font-family: PingFang SC;
				font-weight: 500;
				color: #666666;
			}
		}
	}

	#RightNav {
		position: relative;
		overflow-y: auto;
		width: 13.6rem;
		height: 100%;
		background: #fff;
	}

	.bottominfo {
		margin: 1.84rem 0.8rem 0 1.28rem;
		// position: absolute;
		bottom: 0;
		left: 20px;
		right: 20px;
		// padding: 25px 0 30px;
		list-style: none;
		// border-top: 1px solid #ebeff9;

		div {
			display: block;
			padding: 0 0 0.4rem 1.12rem;
			background: no-repeat;
			// line-height: 0.6rem;

			color: #666;

			a {
				color: #1F85FC;
				text-decoration: underline;
			}

			&.download {
				background-image: url(../assets/images/center/ico-right-neo.png);
			}

			&.phone {
				background-image: url(../assets/images/center/ico-right-number.png);
			}

			&.time {
				background-image: url(../assets/images/center/ico-right-time.png);
			}

			&.email {
				background-image: url(../assets/images/center/ico-right-serviceemail.png);
			}

		}
	}

	.myFree {
		margin-bottom: 0.32rem;
		justify-content: space-between;
		padding: 0.32rem 0.8rem 0.16rem 0.8rem;
		border-radius: 0.4rem;
		background: url('../assets/images/center/my_free_bj.png') no-repeat center/cover;

		.myFreeContent {
			.freeText {


				.freeText01 {
					font-family: PingFang SC;
					font-weight: bold;
					color: #1F85FC;
				}

				.freeText02 {
					font-family: PingFang SC;
					font-weight: 500;
					color: #666666;
				}
			}
		}

		.free_back {
			display: flex;

			align-items: center;

			img {
				height: 0.8rem;
				width: 0.8rem;
			}
		}
	}

	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;

		height: 100%;
	}

	.block {
		width: 14.4rem;
		background-color: #fff;
		border-radius: 0.4rem;

		.title {
			height: 2.4rem;
			text-align: center;
			line-height: 2.4rem;
			font-size: 0.72rem;
			font-family: PingFang SC;
			font-weight: bold;
			color: #333333;
		}

		.tips {
			font-size: 0.56rem;
			height: 0.6rem;
			line-height: 0.6rem;
			padding-left: 1.2rem;
			margin-bottom: 0.48rem;
			color: rgb(102, 102, 102);
		}

		.exchange_ipt {
			width: 12rem;
			margin-left: 1.2rem;
			border-radius: 0.32rem;
			border: 1px solid #999;
		}

		.footer_btn {
			display: flex;
			justify-content: space-between;
			width: 100%;
			height: 1.6rem;
			margin: 2rem 0 0.8rem 0;
			padding: 0 2rem;

			.cancle {
				border-radius: 1.28rem;
				line-height: 1.6rem;
				height: 1.6rem;
				white-space: nowrap;
				cursor: pointer;
				background: #F0F2F5;
				font-family: PingFang SC;
				font-weight: bold;
				color: #1F85FC;
				text-align: center;
				font-size: 0.64rem;
				width: 4.8rem;
			}

			.confrime {
				line-height: 1.6rem;
				border-radius: 1.28rem;
				height: 1.6rem;
				white-space: nowrap;
				cursor: pointer;
				background: #1F85FC;
				font-family: PingFang SC;
				font-weight: bold;
				color: #fff;
				text-align: center;
				font-size: 0.64rem;
				width: 4.8rem;
			}
		}
	}

	.XrfreeContent {
		background: #fff;
		padding: 0 15px 20px 15px;
		border-radius: 0.15rem;
		// height: 3.44rem;
		position: relative;

		.newuserhavegift {
			width: 95px;
			height: 26.5px;
			transform: translateY(-6px);

		}

		.dialog_title {
			height: 0.8rem;
			line-height: 0.8rem;
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: 600;
			color: #1f85fc;

			span {
				display: inline-block;
				color: #ff5962;
			}
		}

		.dialog_des {
			margin: 0 auto;
			font-size: 0.12rem;
			height: 1.2rem;
			line-height: 1.2rem;
			font-family: PingFang SC;
			font-weight: 500;
			color: #fff;
			background: rgba(102, 102, 102, 0.5);
			border-radius: 0.4rem;
			width: 9.6rem;
			margin-top: 0.4rem;
			margin-bottom: 0.8rem;
		}

		.img-newusergiftmore {
			margin-bottom: 0.8rem;
			height: 5.2rem;
		}

		.confirm1 {
			width: 100%;
			border-radius: 0.92rem;
			font-size: 0.72rem;
			height: 1.6rem;
			color: #fff;
			line-height: 1.6rem;
			background: #1f85fc;

		}
	}

	.bullet-box-close {
		margin-top: 1.2rem;
		width: 1rem;
		height: 1rem;
	}

	/* 弹框蒙层 */
	.pagebodyWrap {
		z-index: 999;
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		overflow: hidden;
	}
	
	.pagebodyWrap .bullet-box-wrap {
		width: 13.5rem;
		position: absolute;
		top: 20%;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;
	}
	
	.crmdown1 {
		width: 100%;
		border-radius: 15px 15px 0 0;
	}
	
	.crmfreeContent {
		background: #fff;
		padding: 21px 15px;
		border-radius: 15px;
		position: relative;
	}
	
	.crmfreeContent .learningCardCon {
	
		margin-top: 9px;
		overflow-x: auto;
		overflow-y: hidden;
		width: 100%;
	
	}
	
	
	
	.learningCardCon::-webkit-scrollbar {
		width: 1px;
		height: 0.4rem;
	}
	
	/*滚动条滑块*/
	.learningCardCon::-webkit-scrollbar-thumb {
		border-radius: 0.4rem;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.07);
		background: rgba(0, 0, 0, 0.07);
	}
	
	/*滚动条轨道*/
	.learningCardCon::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
		border-radius: 0.4rem;
		background: #ccc;
		display: none;
	}
	
	
	
	
	.crmfreeContent .twoList {
		justify-content: space-between;
	}
	
	.crmfreeContent .oneList {
		justify-content: space-between;
	}
	
	.crmfreeContent .learningCardCon .learningCardList {
		text-align: center;
		margin-right: 10px;
		width: 115px;
		height: 2.4rem;
		background: #f7f8ff;
		border: 1px solid #b3b3b3;
		border-radius: 5px;
		flex-shrink: 0;
		white-space: nowrap;
		cursor: pointer;
	
	}
	
	.crmfreeContent .learningCardCon .learningCardList .productName {
		height: 14px;
		line-height: 14px;
		margin-top: 20px;
		margin-bottom: 10px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #333333;
	}
	
	.crmfreeContent .learningCardCon .learningCardList .suggestPrice {
		height: 20px;
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FF5962;
		align-items: center;
		text-align: center;
		justify-content: center;
	
	
	}
	
	.crmfreeContent .learningCardCon .learningCardList .suggestPrice .val {
		height: 20px;
		line-height: 20px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: bold;
	}
	
	.crmfreeContent .learningCardCon .learningCardList:last-child {
		margin-right: 0px;
	}
	
	.crmfreeContent .learningCardCon .activeCard {
		background: #FFF5F6;
		border: 1px solid #FF5962;
	}
	
	
	.crmfreeContent .crmTitle {
		width: 75px;
		height: 14px;
		position: absolute;
		top: -4px;
		left: 50%;
		transform: translateX(-50%);
	}
	
	
	.crmfreeContent .rqcode-title {
		margin-top: 22px;
		justify-content: center;
		text-align: center;
		height: 16px;
		line-height: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-bottom: 22px;
	
	
	}
	
	.crmfreeContent .rqcode-title div {
		color: rgba(251, 194, 112, 1);
	}
	
	.crmfreeContent .share-qrcode-img1 {
		width: 100%;
		margin-bottom: 22px;
	
	
	}
	
	.crmfreeContent .share-qrcode-img1 img {
		height: 130px;
		display: block;
		margin: 0 auto;
	}
	
	.crmfreeContent .rqcode-item {
		height: .72rem;
		line-height: .72rem;
		text-align: center;
		position: absolute;
		top: 20px;
		width: 100%;
		font-family: PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
		font-size: .72rem;
	}
	
	.crmfreeContent .img-newusergiftmore {
		margin-bottom: 0.2rem;
		width: 100%;
		margin-top: 0.2rem;
	}
	
	.crmfreeContent .confirm1 {
		width: 100%;
		border-radius: 0.8rem;
		font-size: 0.56rem;
		height: 1.6rem;
		color: #fff;
		line-height: 1.6rem;
		background: #1F85FC;
		font-family: PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/RightNav.vue